// extracted by mini-css-extract-plugin
export default {"action":"FeatureAction_action__nG6qa","actionIcon":"FeatureAction_actionIcon__qCNKN"};